import { UseTournamentsBySlugQueryKeyProps } from './props';
import { TournamentsQueryKeys } from '../../queryKey';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { fetchTournamentsWithStatsBySlug } from './service';
import { TournamentWithStats } from '@/models/tournament/with-stats';
import { useRouter } from 'next/router';

export function useTournamentsBySlug() {
  const { query: routerQuery } = useRouter();
  const slug = routerQuery?.slug as string;

  const queryKey: UseTournamentsBySlugQueryKeyProps = [
    TournamentsQueryKeys.BySlug,
    { slug },
  ];

  const { data, isPending, fetchStatus, ...query } = useQuery<
    TournamentWithStats,
    AxiosError<GenericError>,
    TournamentWithStats,
    UseTournamentsBySlugQueryKeyProps
  >({
    queryKey,
    queryFn: fetchTournamentsWithStatsBySlug,
    refetchOnWindowFocus: false,
    staleTime: 5 * 1000,
    enabled: !!slug,
  });

  return {
    ...query,
    data,
    isLoading: isPending && fetchStatus !== 'idle',
  };
}
